import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface NeutralActionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
}

export function NeutralActionButton({
  children,
  type = 'button',
  className = '',
  ...props
}: NeutralActionButtonProps) {
  return (
    <button
      type={type}
      className={[
        'inline-flex h-9 items-center rounded-[10px] border border-[rgba(26,26,26,0.08)] bg-[rgba(255,255,255,0.82)] px-3 text-[13px] font-medium text-[var(--foreground)] transition-colors hover:bg-[rgba(255,255,255,0.94)]',
        className,
      ].join(' ')}
      {...props}
    >
      {children}
    </button>
  );
}
